export const getRoutePath = (path: string, relative = false): string => {
  if (relative) {
    return path.startsWith('/') ? path.substring(1) : path;
  }
  return path;
};
